import { useBlocksConfig, useSyncer } from "@pathwright/blocks-engine"
import { MediaManager } from "@pathwright/legacy-media-manager"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import PropTypes from "prop-types"
import { AddAttachmentButtonUI, AttachmentsAddWrapper } from "../ui"

export const AddAttachmentButton = ({ onClick, label, disabled }) => {
  const { tc } = useTranslate()

  return (
    <AddAttachmentButtonUI
      onClick={onClick}
      styleType="empty"
      stretch
      color="#666"
      disabled={disabled}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          padding: "7px 0"
        }}
      >
        <Pathicon icon="plus-circle" style={{ marginRight: "0.5rem" }} />
        <span style={{ marginBottom: "-2px", marginTop: "2px" }}>
          {label || tc("Add Attachment")}
        </span>
      </div>
    </AddAttachmentButtonUI>
  )
}

export const AttachmentsAdd = ({ onAddAttachment }) => {
  const { userID, accountID, isSuperuser, contextKey } = useBlocksConfig()
  const { blocksContext } = useSyncer()

  return (
    <AttachmentsAddWrapper>
      <MediaManager
        contextKey={contextKey}
        documentScope={blocksContext?.documentScope}
        mediaStoragePath={blocksContext?.mediaStoragePath}
        mediaType="any"
        onChooseMedia={onAddAttachment}
        userID={userID}
        accountID={accountID}
        renderButton={({ onClick }) => (
          <AddAttachmentButton onClick={onClick} />
        )}
        isSuperuser={isSuperuser}
      />
    </AttachmentsAddWrapper>
  )
}

AttachmentsAdd.propTypes = {
  onAddAttachment: PropTypes.func.isRequired
}

export default AttachmentsAdd
